import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "./ui/accordion";
import { faqs as staticFaqs } from "../data/siteData";
import { useZeoContent } from "../lib/ZeoContentContext";

export default function FAQ() {
  const { faqs: adminFaqs } = useZeoContent();
  const faqs = adminFaqs && adminFaqs.length > 0 ? adminFaqs : staticFaqs;

  return (
    <section className="py-20 md:py-28 lg:py-32 bg-[#F8F8F8]" data-testid="faq-section">
      <div className="frida-container">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16">
          <div className="lg:col-span-4">
            <div className="text-xs tracking-[0.25em] uppercase text-[#A85C34] font-medium mb-3">
              · SSS ·
            </div>
            <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl text-[#222222] tracking-tight leading-[1.1]" data-testid="faq-title">
              Sıkça Sorulan <span className="italic text-[#A85C34]">Sorular</span>
            </h2>
            <p className="mt-6 text-[#555555] leading-relaxed">
              Aradığınız cevabı bulamadıysanız 7/24 hizmet veren danışmanlarımız size yardımcı olmaktan memnuniyet duyar.
            </p>
          </div>

          <div className="lg:col-span-8">
            <Accordion type="single" collapsible className="space-y-3" defaultValue="item-0" data-testid="faq-accordion">
              {faqs.map((f, i) => (
                <AccordionItem
                  key={i}
                  value={`item-${i}`}
                  className="bg-white border border-[#EAEAEA] rounded-2xl px-6 lg:px-8 [&[data-state=open]]:border-[#A85C34] transition-colors"
                  data-testid={`faq-item-${i}`}
                >
                  <AccordionTrigger className="font-serif text-lg md:text-xl text-[#222222] py-5 lg:py-6 text-left hover:no-underline">
                    {f.q}
                  </AccordionTrigger>
                  <AccordionContent className="text-[#555555] leading-relaxed pb-6 text-base">
                    {f.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        </div>
      </div>
    </section>
  );
}
